/**
 * on desktop and tablet: header should become smaller on scrolling
 */

var scrollPosition = 0;
var scrollTrigger = 10; // trigger behaviour if scrolled more than 10px

const scrollClasses = {
  scrolled: 'i4-page--scrolled',
  scrolling: 'i4-page--scrolling',
};

const getScrollPosition = function () {
  return window.pageYOffset || document.documentElement.scrollTop || 0;
};

const scrollBehaviour = function () {
  const body = document.body;

  scrollPosition = getScrollPosition();

  if (scrollPosition > scrollTrigger) {
    // scrolled stated
    if (body.classList.contains(scrollClasses.scrolling)) {
      body.classList.remove(scrollClasses.scrolling);
    }
    if (!body.classList.contains(scrollClasses.scrolled)) {
      body.classList.add(scrollClasses.scrolled);
    }
  } else if (scrollPosition > 0 && scrollPosition < scrollTrigger) {
    // transitioning stated
    if (body.classList.contains(scrollClasses.scrolled)) {
      body.classList.remove(scrollClasses.scrolled);
    }
    if (!body.classList.contains(scrollClasses.scrolling)) {
      body.classList.add(scrollClasses.scrolling);
    }
  } else {
    // non-scrolled state
    if (body.classList.contains(scrollClasses.scrolled)) {
      body.classList.remove(scrollClasses.scrolled);
    }
    if (body.classList.contains(scrollClasses.scrolling)) {
      body.classList.remove(scrollClasses.scrolling);
    }
  }
};

window.addEventListener('wheel', scrollBehaviour);
window.addEventListener('scroll', scrollBehaviour);
window.addEventListener('load', scrollBehaviour);
